// Display-layer score helper.
//
// Backend-issued ``presented_score`` is the canonical user-facing number.
// It re-anchors the user's score around 50 once a 7-snapshot baseline
// exists. See app/services/rci_query_service.py for the formula.
//
// We always read ``presented_score`` straight from the API when present,
// and fall back to ``rci_total * 100`` when a snapshot pre-dates the
// presented-score rollout (e.g. cached responses, older test fixtures).
// Never call ``presentedScore`` on the practitioner-report endpoint —
// that surface intentionally renders raw rci_total as "Clinical Score".
export function presentedScore(snapshot) {
  if (!snapshot) return 0;
  if (typeof snapshot.presented_score === "number") {
    return snapshot.presented_score;
  }
  const raw = snapshot.rci_total || 0;
  return Math.round(raw * 100);
}
